/**
 * React Query Hooks
 *
 * Exports all query hooks for API data management.
 */

export { useAdTags, adTagsKeys } from './useAdTagsQuery';
export { useAreaByIp, useAreaByResourceId, useUpdateArea, areaKeys } from './useAreaQuery';
export { useEncodedBoundary, boundaryKeys } from './useBoundaryQuery';
export { useCurrentArea, useSetCurrentArea, useNearMeArea, useSetNearMeArea, currentAreaKeys } from './useCurrentArea';
export {
  useCurrentResolvedSearch,
  useSetCurrentResolvedSearch,
  currentResolvedSearchKey,
} from './useCurrentResolvedSearch';
export { searchUnitCountQueryOptions, useSearchListings } from './useListingQuery';
export {
  hpToursKeys,
  inquiryKeys,
  listingDetailKeys,
  recentSearchKeys,
  renterProfileKeys,
  savedSearchKeys,
  searchKeys,
  userListingKeys,
} from './queryKeys';
export {
  useCurrentUser,
  useSetCurrentUser,
  useEmailPasswordLogin,
  useLogout,
  useUpdateProfile,
  useFreepassLogin,
  useGoogleAuth,
  useAppleAuth,
  useFreepassAuth,
  useSendResetPasswordEmail,
  useSendFeedback,
  userKeys,
} from './useUserQuery';
export { useUserListings } from './useUserListings';
export type { UserListingsData } from './useUserListings';
export {
  useDisplaySearchPromptPostInquiry,
  useInquiryMessageCache,
  useSubmitInquiry,
  useValidateContactInfo,
} from './useInquiry';
export { useRenterProfile, useUpdateRenterProfile } from './useRenterProfile';
export { useAddUserItem, useRemoveUserItem } from './useUserItems';
export { useDeferredViewedListingMutation } from './useDeferredViewedListingMutation';
export { useReportListing } from './useReportListing';
export {
  useSavedSearches,
  useCreateSavedSearch,
  useUpdateSavedSearch,
  useDeleteSavedSearch,
} from './useSavedSearches';
export { useRecentSearch, useUpdateRecentSearch, type RecentSearchSeed } from './useRecentSearch';
export {
  useNotificationSettings,
  useEmailSubscriptions,
  useToggleNotification,
  useToggleAllNotifications,
  notificationKeys,
} from './useNotificationSettings';
export { useHomeHubCollections, homeHubKeys } from './useHomeHubQuery';
export type { HomeHubCollectionData } from './useHomeHubQuery';
export { useNearbyAreas, useAreaFacts, useAreaFactsByBeds, exploreAreaKeys } from './useExploreAreas';
